import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";

export default function AcademicCouncil({ 
  accent = "#115e32",
  pageTitle = "Academic Council | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	const getPhotoUrl = async (photo) => {
	  if (!photo) return "/images/default-officer.png";

	  try {
		const localResponse = await fetch(photo, { method: "HEAD" });

		if (localResponse.ok) {
		  return photo;
		}
	  } catch (error) {
		// Local file doesn't exist
	  }

	  return `${import.meta.env.VITE_API_SOURCE_URL}${photo}`;
	};
	const senior = [
	{
		title:"Bir Muktijoddha",  
		name: "Professor Md.Zahid Hossain Sharif, Phd",
		designation: "President",
		udesignation: "Vice-Chancellor, UCTC",    
		email: "zhsharif@uctc.edu.bd",
		address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
		photo: "assets/custom/syndicate/img/Professor%20Md.%20Zahid%20Hossain%20Sharif,%20PhD.jpg",
		details: "#",
	},
  {
      name: "Prof.Dr. Harunur Rashid",
      designation: "Member",
      udesignation: "Dean,School of Business, UCTC",
      email: "dean.sob@uctc.edu.bd",
      address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
      photo: "assets/custom/AcademicCouncil/img/Prof.%20Dr.%20Mohammad%20Kaiko",
      details: "#",
    },
    {
      name: "Prof.Dr. M Abdus Samad",
      designation: "Member",
      udesignation: "Dean,School of Science and Engineering, UCTC",
      email: "",
      address: "",
      photo: "assets/custom/syndicate/img/Prof.%20Dr.%20M.%20Abdus%20Samad.jpg",
      details: "#",
    },
    {
      name: "Md. Abu Jabed",
      designation: "Member",
      udesignation: "Associate Professor & Head, Computer Science & Engineering, UCTC",
      email: "jabed@uctc.edu.bd",
      address: "",
      photo: "assets/img/Abu-Jabed.jpg",
      details: "#",
    },
    {
      name: "Mohammad Taher Hossain Salim",
      designation: "Member",
      udesignation: "Associate Professor & Head, English Language and Literature, UCTC",
      email: "tahersalim@uctc.edu.bd",
      address: "",
      photo: "/img/TaherHossain.png",
      details: "#",
    },
    {
      name: "Dr. Md Abu Jahid",
      designation: "Member",
      udesignation: "Associate Professor & Head, School of Business, UCTC",
      email: "abu.jahid@uctc.edu.bd",
      address: "",
      photo: "/img/AbuJahid.jpeg",
      details: "#",
    },
    {
      name: "Mohammad Moshraf Hossain",
      designation: "Member",
      udesignation: "Associate Professor & Head, Department of Islamic Studies, UCTC",
      email: "",
      address: "",
      photo: "/img/Azhari.png",
      details: "#",
    },

	
	

   
    
    {
      name: "Md Nabiul Alam",
      designation: "Member",
      udesignation: "Chairman, Board of Trustees, UCTC",
      email: "",
      address: "",
      photo: "/img/nabi.png",
      details: "#",
    },

     
    {
      name: "Mohammad Osman",
      designation: "Member",
      udesignation: "Founder & Secretary BoT, UCTC",
      email: "founder@uctc.edu.bd",
      address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
      photo: "assets/custom/syndicate/img/Mohammad%20Osman.jpg",
      details: "#",
    },
    {
      name: "Nahida Sultana Yasmin",
      designation: "Member",
      udesignation: "BoT, UCTC",
      email: "",
      address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
      photo: "/img/nahida.png",
      details: "#",
    },
    
		
	{
      name: "Professor A. B. M. Abu Noman",
      designation: "Member",
      udesignation: "Professor, Law, University of Chittagong",
      email: "abu_noman1974@yahoo.com",
      address: "",
      photo: "/img/Abunoman.jpg",
      details: "#",
    }, 
    {
      name: "Dr. Jamal Uddin Ahamed",
      designation: "Member",
      udesignation: "Professor, Mechanical Engineering, CUET",
      email: "jamal@cuet.ac.bd",
      address: "",
      photo: "assets/custom/syndicate/img/Dr.%20Jamal%20Uddin%20Ahamed.jpg",
      details: "#",
    },       
	
	{
      name: "Dr. Mohammad Nurul Absar",
      designation: "Member",
      udesignation: "Controller of Examinations, UCTC",
      email: "mnabsar@uctc.edu.bd",
      address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
      photo: "/img/Absar.png",
      details: "#",
    },
    
    
    {
      name: "Prof.Dr. Mohammad Kaikobad",
      designation: "Member",
      udesignation: "Distinguish Professor, Brac University",
      email: "mkbd1234@yahoo.com",
      address: "",
      photo: "assets/custom/AcademicCouncil/img/Prof.%20Dr.%20Mohammad%20Kaikobad.jpg",
      details: "#",
    },
    
	
	
	{
      name: "Salauddin Ahmed",
      designation: "Member Secretary",
      udesignation: "Registrar, UCTC",
      email: "registrar@uctc.edu.bd",
      address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
      photo: "assets/custom/syndicate/img/Salahuddin%20Ahmed.jpg",
      details: "#",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fffdf6] to-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE] text-[#014864] py-20 text-center">
        <motion.h1
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-4xl md:text-6xl font-extrabold"
        >
          Academic Council
        </motion.h1>
        <p className="mt-4 text-lg opacity-90">
          
        </p>
      </section>

      {/* Senior Officer */}
      <section className="container mx-auto px-6 py-16">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1 }}
          className="bg-white rounded-2xl shadow-lg p-8 flex flex-col md:flex-row items-center gap-8 hover:shadow-xl transition-all duration-300"
        >
          <img
			src={senior.photo}
			alt={senior.name}
			onError={(e) => {
				const img = e.currentTarget;
				if (img.dataset.fallback === "api") {
				  img.dataset.fallback = "default";
				  img.src = "/img/user-default.jpg";
				  return;
				}

				img.dataset.fallback = "api";
				img.src = `${import.meta.env.VITE_API_SOURCE_URL}${senior.photo}`;
			}}
            
            className="w-48 h-56 object-cover rounded-xl border-4 border-[#014864]"
          />
          <div className="flex-1 space-y-3">
			<h2 className="text-1xl font-bold text-gray-800">{senior.title}</h2>
            <h2 className="text-2xl font-bold text-gray-800">{senior.name}</h2>
            <p className="text-[#2563eb] font-semibold">{senior.designation}</p>
            <p className="text-gray-600">{senior.office}</p>
            <div className="space-y-1 text-gray-600 text-sm">
              
              <p className="flex items-center gap-2"><Mail size={16}/> {senior.email}</p>
              <p className="flex items-center gap-2"><MapPin size={16}/> {senior.address}</p>
            </div>
            <a
              href={senior.details}
              className="inline-block mt-4 px-6 py-2 bg-gradient-to-r from-[#014864] to-[#2563eb] text-white rounded-lg shadow hover:opacity-90 transition"
            >
              View Details
            </a>
          </div>
        </motion.div>
      </section>

      {/* Other Officers */}
      <section className="container mx-auto px-6 pb-20">
        <div className="grid md:grid-cols-3 gap-8">
          {senior.map((officer, index) => (
            <motion.div
              key={index}
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300"
            >
              <img
                src={officer.photo}
                alt={officer.name}
				onError={(e) => {
					const img = e.currentTarget;
					if (img.dataset.fallback === "api") {
					  img.dataset.fallback = "default";
					  img.src = "/img/user-default.jpg";
					  return;
					}

					img.dataset.fallback = "api";
					img.src = `${import.meta.env.VITE_API_SOURCE_URL}${officer.photo}`;
				}}
                className="w-32 h-40 mx-auto rounded-lg object-cover border-2 border-[#2563eb]"
              />
              <h3 className="mt-4 text-xl font-bold text-gray-800">
                {officer.name}
              </h3>
              <p className="text-[#2563eb] text-sm font-semibold">
                {officer.designation}
              </p>
              <p className="text-gray-600 text-sm">{officer.office}</p>
              <div className="mt-3 text-gray-600 text-sm space-y-1">
                
                <p className="flex items-center justify-center gap-2">
                  <Mail size={14}/> {officer.email}
                </p>
                <p className="flex items-center justify-center gap-2">
                  <MapPin size={14}/> {officer.address}
                </p>
              </div>
              <a
                href={officer.details}
                className="inline-block mt-4 px-4 py-2 bg-gradient-to-r from-[#2563eb] to-[#014864] text-white rounded-lg text-sm hover:opacity-90 transition"
              >
                View Details
              </a>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
